import { createContext, type RefObject } from 'react';
import { noop } from 'libs';

interface SavedFilterContextValue {
  buttonAsideRef: RefObject<HTMLButtonElement | null> | null;
  buttonTopRef: RefObject<HTMLButtonElement | null> | null;
  handleToggle: (panel: string) => void;
  onClose: () => void;
  savedFilterPanelOpen: boolean;
}

const SavedFilterContext = createContext<SavedFilterContextValue>({
  buttonAsideRef: null,
  buttonTopRef: null,
  handleToggle: noop,
  onClose: noop,
  savedFilterPanelOpen: false,
});

export default SavedFilterContext;
